module.exports = __webpack_public_path__ + "img/single_pictures_7.d3c4ce6d.jpg";